import {styled} from '../theme-provider';

export const Loader = styled.div<{size: number}>`
  border-radius: 50%;
  width: ${({size}) => `${size}px`};
  height: ${({size}) => `${size}px`};

  &:after {
    border-radius: 50%;
    width: ${({size}) => `${size}px`};
    height: ${({size}) => `${size}px`};
  }

  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 2px solid ${({theme}) => theme.palette.state.error.background};
  border-right: 2px solid ${({theme}) => theme.palette.state.error.background};
  border-bottom: 2px solid ${({theme}) => theme.palette.state.error.background};
  border-left: 2px solid ${({theme}) => theme.palette.general.smart};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

/** Full-viewport centered host for auth/bootstrap Suspense loaders. */
export const PageLoaderRoot = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  box-sizing: border-box;
  background: ${({theme}) => theme.palette.generalAlt.background.primary};

  /* Spinner defaults to margin: 60px auto (top-biased); pin to true center. */
  & ${Loader} {
    margin: 0;
  }
`;
